import { RequestResponse } from '@core/services/request/model/request.model';
import { MasterRoadTypeApi } from '@core/api/model/master/master-road-type-api.model';
import { StringIdName } from '@core/domain/model/master/string-id-name.model';

export class MasterRoadTypesMapper {
  public static requestFromApiToModel(api: RequestResponse<Array<MasterRoadTypeApi>>): RequestResponse<Array<StringIdName>> {
    return {
      ...api,
      data: api.data.map(({ codigo, nombre }) => ({ id: codigo, name: nombre })),
    };
  }
}
